import { render, staticRenderFns } from "./ScreenPagos2.vue?vue&type=template&id=726d97a0&scoped=true"
import script from "./ScreenPagos2.vue?vue&type=script&lang=js"
export * from "./ScreenPagos2.vue?vue&type=script&lang=js"
import style0 from "./ScreenPagos2.vue?vue&type=style&index=0&id=726d97a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726d97a0",
  null
  
)

export default component.exports